import React from "react";
import {
    Box,
    Backdrop,
    Slide,
    Paper,
    IconButton,
    useMediaQuery,
    Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ThemeProvider } from '@mui/material/styles';
import theme from '../styles/theme';
import CheckoutContent from './CheckoutContent';
import logo from '../assets/rounded_logo.svg';

interface CheckoutOverlayProps {
    open: boolean;
    onClose: () => void;
    onError: () => void;
    source: string;
    listingId?: string;
}

const CheckoutOverlay: React.FC<CheckoutOverlayProps> = ({ open, onClose, onError, source, listingId }) => {
    const isDesktop = useMediaQuery('(min-width:960px)');

    return (
        <ThemeProvider theme={theme}>
            <Backdrop
                open={open}
                sx={{
                    zIndex: theme => theme.zIndex.drawer + 1,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                }}
                onClick={(e) => {
                    if (e.target === e.currentTarget) onClose();
                }}
            >
                <Slide direction="up" in={open} mountOnEnter unmountOnExit>
                    <Box
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%'
                        }}
                    >
                        <Paper
                            sx={{
                                p: 0,
                                borderRadius: 4,
                                width: isDesktop ? 400 : '100%',
                                maxWidth: isDesktop ? 400 : '100%',
                                maxHeight: '95vh',
                                overflowY: 'auto',
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            {/* Header with close button */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    px: 2,
                                    py: 2,
                                    borderBottom: '1px solid #eee',
                                }}
                            >
                                <Box> <img src={logo} alt="Heyy Property Logo" style={{height: '48px', width: 'auto' }}/></Box>
                                <IconButton onClick={onClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                            {/* Content */}
                            <CheckoutContent source={source} onError={onError} onClose={onClose} listingId={listingId} />
                        </Paper>
                    </Box>
                </Slide>
            </Backdrop>
        </ThemeProvider>
    );
};

export default CheckoutOverlay;